import { get, post, put, remove } from './HttpService';
import {
	ChapterDto,
	CreateChapterCommand,
	PaginatedListOfChapterDto,
	UpdateChapterCommand
} from '../models/models';
import { Chapter } from '../redux/chapters/chapter.types';
import { hasFailed } from '../utils';
import { HttpResponse } from '../redux/http/http.types';
import { dispatchSnackbar } from '../services/SnackbarService';

export async function postChapter(chapter: Chapter): Promise<string> {
	const command: CreateChapterCommand = {
		name: chapter.name,
		thumbnailAssetId: chapter.thumbnailUrl,
		order: chapter.order,
		zone: chapter.zone,
		licenceIds: chapter.licenceIds
	};

	const response: HttpResponse<string> = await post<
		string,
		CreateChapterCommand
	>(`chapter`, `chapters`, command);

	dispatchSnackbar('hoofdstuk', 'POST', !hasFailed(response));

	return response.data!;
}

export async function getChaptersByLicenceIds(
	licenceIds: string[]
): Promise<ChapterDto[]> {
	const queryString: string = licenceIds.join('&licenceIds=');

	const response: HttpResponse<ChapterDto[]> = await get<ChapterDto[]>(
		`chapter`,
		`chapters/getByLicenceIds?licenceIds=${queryString}`
	);

	return response.data!;
}

export async function getAllChapters(
	queryString: string
): Promise<PaginatedListOfChapterDto> {
	const response: HttpResponse<PaginatedListOfChapterDto> =
		await get<PaginatedListOfChapterDto>(
			'chapter',
			`chapters${queryString}`
		);

	return response.data!;
}

export async function getChapter(id: string): Promise<ChapterDto> {
	const response: HttpResponse<ChapterDto> = await get<ChapterDto>(
		'chapter',
		`chapters/${id}`
	);

	return response.data!;
}

export async function putChapter(chapter: Chapter): Promise<void> {
	const command: UpdateChapterCommand = {
		id: chapter.id as string,
		name: chapter.name,
		thumbnailAssetId: chapter.thumbnailUrl,
		order: chapter.order,
		zone: chapter.zone,
		licenceIds: chapter.licenceIds
	};

	const response: HttpResponse = await put<UpdateChapterCommand>(
		`chapter`,
		`chapters`,
		command
	);

	dispatchSnackbar('hoofdstuk', 'PUT', !hasFailed(response));
}

export async function removeChapter(id: string): Promise<void> {
	const response: HttpResponse = await remove(`chapter`, `chapters/${id}`);

	dispatchSnackbar('hoofdstuk', 'DELETE', !hasFailed(response));
}
